/**
 * 模組代碼 : -
 * 模組說明 : (共用模組) 彈出式訊息視窗
 * @module web/components/MessageModal
 */

// ----- import from npm modules -----
import React, {useState, useEffect} from 'react';
import enumList from 'web/utils/enumList';

// ----- constants and enums -----
const MessageModalModeEnums = {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  LOADING: 'loading',
};

const MessageModal = React.forwardRef((props, ref) => {
  const {mode, title, message, onClose, isDisabled} = props;

  const [style, setStyle] = useState({});
  const modeStyles = {
    error: {
      badgeClass: 'modal__title__badge--alert',
      iconHref: '#ico-error',
    },
    warning: {
      badgeClass: 'modal__title__badge--alert',
      iconHref: '#ico-error',
    },
    loading: {
      badgeClass: 'modal__title__badge--warning',
      iconHref: '#ico-info',
    },
    info: {
      badgeClass: 'modal__title__badge--success',
      iconHref: '#ico-info',
    },
  };

  // 将换行符转换为 <br /> 标签
  // const formattedMessage = message.split('<br />').map((line, index) => (
  //   <React.Fragment key={index}>
  //     {line}
  //     <br />
  //   </React.Fragment>
  // ));

  useEffect(() => {
    setStyle(modeStyles[mode]);
  }, [mode]);

  useEffect(() => {
    const modal = ref.current;
    modal.addEventListener('hidden.bs.modal', onClose);
    return () => {
      modal.removeEventListener('hidden.bs.modal', onClose);
    };
  }, [ref]);

  if (message.includes('401 Unauthorized')) {
    return <div></div>;
  }

  return (
    <div
      ref={ref}
      className="modal fade"
      id="modalMessage"
      data-bs-backdrop={isDisabled ? 'static' : 'true'}
      data-bs-keyboard={isDisabled ? 'false' : 'true'}
      tabIndex="-1"
      aria-labelledby="modalMessageLabel"
    >
      <div className="modal-dialog modal-sm modal-dialog-centered">
        <form className="modal__form modal-content" id="modalMessageForm">
          <div className="modal-header border-bottom-0">
            <h1 className="modal-title fs-5" id="modalMessageLabel">
              <div
                className={`modal__title__badge ${style.badgeClass}`}
                id="modalAlertBadge"
              >
                {mode === MessageModalModeEnums.ERROR ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="red"
                    className="bi bi-exclamation-triangle"
                    viewBox="0 0 16 16"
                  >
                    <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z" />
                    <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
                  </svg>
                ) : (
                  ''
                )}
                {mode === MessageModalModeEnums.WARNING ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="red"
                    className="bi bi-exclamation-triangle"
                    viewBox="0 0 16 16"
                  >
                    <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z" />
                    <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
                  </svg>
                ) : (
                  ''
                )}
                {mode === MessageModalModeEnums.INFO ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="green"
                    className="bi bi-info-circle"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                  </svg>
                ) : (
                  ''
                )}
                {mode === MessageModalModeEnums.LOADING ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="white"
                    class="bi bi-hourglass-bottom"
                    viewBox="0 0 16 16"
                  >
                    <path d="M2 1.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1-.5-.5m2.5.5v1a3.5 3.5 0 0 0 1.989 3.158c.533.256 1.011.791 1.011 1.491v.702s.18.149.5.149.5-.15.5-.15v-.7c0-.701.478-1.236 1.011-1.492A3.5 3.5 0 0 0 11.5 3V2z" />
                  </svg>
                ) : (
                  ''
                )}
              </div>
              <div id="modalTitle" className="modal__title__text">
                {title}
              </div>
            </h1>
            <button
              type="button"
              disabled={isDisabled}
              className="btn-close btn-cancel"
              data-bs-dismiss="modal"
              onClick={(e) => {
                e.preventDefault();
                onClose();
              }}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">{message}</div>
          <div className="modal-footer">
            <button
              type="button"
              disabled={isDisabled}
              className="btn btn-cancel"
              data-bs-dismiss="modal"
              onClick={(e) => {
                e.preventDefault();
                onClose();
              }}
            >
              確定
            </button>
          </div>
        </form>
      </div>
    </div>
  );
});

export {MessageModal, MessageModalModeEnums};
